import React from 'react';
import DataServiceTabNav from '../Components/DataService/DataServiceTabNav';
import SavedQueriesComponent from '../Components/DataService/SavedQueriesComponent';

function DataServiceSavedQueriesPage() {
  return (
    <div className="bg-slate-950 text-slate-100">
      <DataServiceTabNav />
      <SavedQueriesComponent />
    </div>
  );
}

export default DataServiceSavedQueriesPage;


